import React from 'react';
import PropTypes from 'prop-types';

import Radiobutton from '../Radio/radioButton';

import './InterestComboBox.css';

export default class InterestComboBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      values: {}
    };
  }

  componentWillMount() {
    if (this.props._value !== undefined) {
      this.setState({ values: this.props._value });
    }
  }

  handleInputBoxChange = (event) => {
    this.setState({ values: { ...this.state.values, [event.target.name]: event.target.value } }, () => {
      this.props.setInputvalue(this.state.values, this.props.name);
    });
  }

  handleRadioChange = (value, name) => {
    name = name.split('-').pop();
    this.setState({ values: { ...this.state.values, [name]: value } }, () => {
      this.props.setInputvalue(this.state.values, this.props.name);
    });
  }

  render() {
    return (
      <div className="interest-combo-box">
        <label className="interest-combo-box__label">{this.props.boxLabel}</label>
        <div className="interest-combo-box__row clearfix">
          <div className="interest-combo-box__input-section">
            <label>{this.props.subLabels[0] || "Base rate"}</label>
            <input type="text"
              name={this.props.subNames[0]}
              value={this.state.values[this.props.subNames[0]] || ''}
              maxLength={this.props.maxChars[0]}
              onChange={this.handleInputBoxChange}
              disabled={this.props.disabled} />
          </div>
          {!this.props.disabled
            ? <div className="interest-combo-box__input-section">
              <label>{this.props.subLabels[1] || "Code"}</label>
              <input type="text"
                name={this.props.subNames[1]}
                value={this.state.values[this.props.subNames[1]] || ''}
                maxLength={this.props.maxChars[1]}
                onChange={this.handleInputBoxChange}
                disabled={this.props.disabled}
                placeholder={this.props.defaultValue && this.props.defaultValue[1]}
              />
            </div>
            : ''
          }
          <div className="interest-combo-box__input-section">
            <label>{this.props.subLabels[2] || "Spread"}</label>
            <input type="text"
              name={this.props.subNames[2]}
              value={this.state.values[this.props.subNames[2]] || ''}
              maxLength={this.props.maxChars[2]}
              onChange={this.handleInputBoxChange}
              disabled={this.props.disabled} />
          </div>
          <div className="interest-combo-box__radio-section">
            <label className="radio-label">
              {this.props.subLabels[3] || "Margin % (of base rate)"}
              <Radiobutton setInputvalue={this.handleRadioChange}
                name={`${this.props.name}-${this.props.subNames[3]}`}
                _value={this.state.values[this.props.subNames[3]]}
                value={(this.props.radioValues && this.props.radioValues[0]) || "marginBaseRate"}
                disabled={this.props.disabled} />
            </label>
          </div>
          <div className="interest-combo-box__radio-section">
            <label className="radio-label">
              {this.props.subLabels[4] || "Fixed value %"}
              <Radiobutton setInputvalue={this.handleRadioChange}
                name={`${this.props.name}-${this.props.subNames[4]}`}
                _value={this.state.values[this.props.subNames[4]]}
                value={(this.props.radioValues && this.props.radioValues[1]) || "fixed"}
                disabled={this.props.disabled} />
            </label>
          </div>
        </div>
        <div className="interest-combo-box__row interest-combo-box__row--no-bottom-margin clearfix">
          <div className="interest-combo-box__input-section">
            <label>{this.props.subLabels[5] || "Minimum interest"}</label>
            <input type="text"
              placeholder={this.props.defaultValue[5]}
              name={this.props.subNames[5]}
              value={this.state.values[this.props.subNames[5]] || ''}
              maxLength={this.props.maxChars[5]}
              onChange={this.handleInputBoxChange}
              disabled={this.props.disabled} />
          </div>
          <div className="interest-combo-box__input-section">
            <label>{this.props.subLabels[6] || "Maximum interest"}</label>
            <input type="text"
              placeholder={this.props.defaultValue[6]}
              name={this.props.subNames[6]}
              value={this.state.values[this.props.subNames[6]] || ''}
              maxLength={this.props.maxChars[6]}
              onChange={this.handleInputBoxChange}
              disabled={this.props.disabled} />
          </div>
        </div>
      </div>
    )
  }
}


InterestComboBox.defaultProps = {
  subNames: [],
  subLabels: [],
  maxChars: []
}

InterestComboBox.propTypes = {
  boxLabel: PropTypes.string.isRequired,
  subLabels: PropTypes.array,
  maxChars: PropTypes.array,
  subNames: PropTypes.array.isRequired,
  setInputvalue: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/common/InterestComboBox/InterestComboBox.js